import { createStore } from "vuex";
import { areastore } from "@/store/modules/areastore"
import { monitorstore } from "@/store/modules/monitorstore"
import { userstore} from "@/store/modules/userstore"
import { devicestore} from "@/store/modules/devicestore"
import { servicestore} from "@/store/modules/servicestore"
import { protokollstore } from "@/store/modules/protokollstore";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    areastore,
    monitorstore,
    userstore,
    devicestore,
    servicestore,
    protokollstore
  },
});
